//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';
// TODO:BRO-1276: import Dropdown from dorado
import LegacyDropdown from '../../ui/LegacyDropdown.vue';

export default {
  components: { LegacyDropdown },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    plansToShow: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      selectedDeal: null,
      selectedPlan: null,
      displayedPlans: [],
      showMoreOptions: false,
      dynamicPlan: {},
    };
  },
  computed: {
    showPricingInfo() {
      return !this.deal.stage_details.is_inactive_indefinitely;
    },
    hasPlus() {
      return get(this, ['$store', 'state', 'session', 'user', 'has_plus'], false);
    },
    dropdownPlaceholder() {
      if (this.deal.use_licensing) {
        if (!this.selectedDeal) {
          return 'Select another tier';
        }

        return (this.deal.plans.find((x) => (
          Number(x.id) === Number(this.selectedDeal)
        )) || {}).public_name;
      }

      return (this.selectedDeal) ? `${this.selectedDeal} Codes` : 'Select More Codes';
    },
    dealList() {
      const deals = []; // return different list when useLicesing is true

      for (let i = this.plansToShow; i <= this.deal.plans.length; i += 1) {
        const plan = this.deal.plans[i - 1];

        deals.push({
          display: this.deal.use_licensing ? plan.public_name : `${plan.codes} Codes`,
          value: this.deal.use_licensing ? plan.id : plan.codes,
        });
      }

      return deals;
    },
  },
  created() {
    if (this.deal.plans.length > this.plansToShow) {
      // Since we have more items than the ones we're displaying
      // the last displayed item will change dynamically based on user selection
      this.displayedPlans = this.deal.plans.slice(0, this.plansToShow - 1);

      this.showMoreOptions = true;
      this.dynamicPlan = this.deal.plans[this.plansToShow - 1];
    } else {
      this.displayedPlans = this.deal.plans;
    }
  },
  methods: {
    pluralizeCode(code) {
      if (this.deal.use_licensing) {
        return '';
      }

      return `(${code} code${code > 1 ? 's' : ''})`;
    },
    updateDeal({ value }) {
      let plan = null;
      // TODO -- Make sure working correctly

      if (this.deal.use_licensing) {
        plan = this.deal.plans.find((x) => Number(x.id) === Number(value));
      } else {
        plan = this.deal.plans.find((x) => Number(x.codes) === Number(value));
      }

      this.selectedDeal = value;
      this.selectedPlan = plan;
      this.dynamicPlan = plan;
    },
    generatePlanName(plan) {
      if (plan.public_name) return plan.public_name;
      if (plan.codes > 2) return 'Multiple';
      if (plan.codes === 2) return 'Double';

      return 'Single';
    },
  },
};
